<template>
  <v-dialog v-model="profileInfoDialog" width="800">
    <v-card v-if="$vuetify.breakpoint.smAndUp">
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <!-- {{ $t("general.about1") }} -->
        <span class="display-1 text-uppercase font-weight-bold">{{
          $t("infoDialogs.private.profile.Title")
        }}</span>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          :title="$t('infoDialogs.private.profile.Close window')"
          class="ma-2"
          outlined
          icon
          large
          @click="closeDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="pr-5 text--primary title">
          {{ $t("infoDialogs.private.profile.PageDescription") }}.
        </p>
      </v-card-text>
    </v-card>
    <!--Phone-->
    <v-card v-else>
      <!--Title and close-->
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <span class="display-1 text-uppercase font-weight-bold">{{
          $t("infoDialogs.private.profile.Title")
        }}</span>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          :title="$t('profile.general.Close Window')"
          class="ma-2"
          outlined
          icon
          large
          @click="closeDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="ma-0 pa-0">
          <!--Description-->
          <v-col cols="12" class="py-0">
            <p class="pr-5 text--primary title">
              {{ $t("infoDialogs.private.profile.PageDescription") }}.
            </p>
          </v-col>
          <v-col cols="12" class="py-0"> </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// Import the i18n
import messages from "../../modules/lang/export";
export default {
  // Communicate with i18n
  i18n: { messages },
  data() {
    return {
      // Define the dialog v-model that we are using
      profileInfoDialog: false,
      // Define if to display Name or not
      DisplayName: false,
      // Define if to display Country or not
      DisplayCountry: false,
      // Define if to display Gender or not
      DisplayGender: false
    };
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
      this.profileInfoDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.profileInfoDialog = false;
    }
  }
};
</script>
